import { useState } from "react"
import { findOrderDetailForWeavingPendingCrudeRolledEvent } from "../../_events/orderDetail/orderDetail.event";
import { message } from "antd";

export const useOrderDetailWeavingPendingCrudeRolled = () => {
    const [data, setData] = useState([]);

    const loadData = () => {
        findOrderDetailForWeavingPendingCrudeRolledEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(error => {
            message.error(error.message);
        });
    }

    return{
        data,
        loadData
    }
}